export default "__VITE_ASSET__BLObOJ6U__"